// extracted by mini-css-extract-plugin
export var navMenu = "header-module--nav-menu--3RTrR";
export var navItem = "header-module--nav-item--3spw1";
export var activeNavItem = "header-module--active-nav-item--2TxT2";
export var mainTitle = "header-module--mainTitle--1BU3F";